<style lang="scss" scoped>
@import '../../styles/mixins.scss';
.box {
  height: 30px;
  width: 30px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  color: #fff;
  border-radius: 50%;
  &.select {
    background: #6982FA;
  }
  &.not-select {
    @include setBorder1px($c: #7C8790, $border-radius: 32px);
  }
}
</style>
<template>
  <div class="container" @click="selectValue">
    <div class="box" :class="value ? 'select' : 'not-select'">
      <SvgIcon
        v-if="value"
        icon-class="check"
        :class-name="className"
        @click.prevent
      ></SvgIcon>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import SvgIcon from '../SvgIcon'
export default {
  name: 'Checkbox',
  props: {
    className: String,
    value: Boolean
  },
  data () {
    return {
    }
  },
  components: {
    SvgIcon
  },
  created () {},
  mounted () {},
  beforeDestroy () {},
  destroyed () {},
  methods: {
    selectValue () {
      this.$emit('input', !this.value)
    }
  }
}
</script>


